import React, { memo } from "react";
import Button from "../../../theme/button/Button";
import Styles from "./Nodes.module.scss";
import { useWorkflow } from "../../providers/WorkflowProvider";
import EmptyFlowLight from "../../../../assets/img/empty-flow-light.svg";
import EmptyFlowDark from "../../../../assets/img/empty-flow-dark.svg";
import { useTheme } from "../../../../contexts/Theme";

function EmptyFlowNode() {
    const { initWorkflow } = useWorkflow();
    const theme = useTheme();

    const emptyFlowImg = theme.getTheme() === "dark" ? EmptyFlowDark : EmptyFlowLight;

    return (
        <div className={Styles["empty-flow-node"]}>
            <img src={emptyFlowImg} alt="Empty Flow" />

            <div>
                <h3>Create Automation</h3>
                <p>
                    Start creating automation
                    <br />
                    by pressing ‘+ Add Actions’
                </p>
            </div>

            <Button.Add variant="primary" onClick={initWorkflow}>
                Add Actions
            </Button.Add>
        </div>
    );
}

export default memo(EmptyFlowNode);
